import { PROVISIONING_SERVICE_ORIGIN } from "../props";

export function useProvisioningServiceURL() {
  return new URL("/", PROVISIONING_SERVICE_ORIGIN).origin;
}
